import axios from "axios";
const instance = axios.create({ baseURL: "https://vanillathebakery.ondemandcrm.co/"}); //window.location.origin//
export default instance;
